import { userAll, userCreate, userUpdate, userDelete, rechargeContactsByUserSearch, userById, userPoint } from "../../routes/api/paths";
import { handleResponse, requestOptions } from "../HandlerService";

export const UsersAllServices = async (params) => {
  const { token, page, search, group_id, group_id_edited, orderBy, orderField, per_page = 10 } = params;
  const options = requestOptions('GET', {}, token);
  return fetch(`${userAll}?page=${page}&per_page=${per_page}${search ? `&search=${search}` : ''}${group_id !== undefined ? `&group_id=${group_id}` : ''}${group_id_edited ? `&group_id_edited=${group_id_edited}` : ''}&orderBy=${orderBy || 'asc'}&orderField=${orderField || 'id'}`
    , options)
    .then(handleResponse)
    .catch(error => Promise.reject({
    status: error
  }));
}

export const UserByIdService = async ({token, id}) => {
  const options = requestOptions('GET', {}, token);
  return fetch(userById(id), options)
    .then(handleResponse)
    .catch(error => Promise.reject({
    status: error
  }));
}

export const UserCreateService = async (params) => {
  const { token, data } = params;
  const options = requestOptions('POST', data, token);
  return fetch(userCreate, options)
    .then(handleResponse)
    .catch(error => Promise.reject({
    status: error
  }));
}

export const UserUpdateService = async (params) => {
  const { token, data } = params;
  const options = requestOptions('PUT', data, token);
  return fetch(userUpdate, options)
    .then(handleResponse)
    .catch(error => Promise.reject({
    status: error
  }));
}

export const UserDeleteService = async (params) => {
  const { token, ids } = params; // ids = [1,2,3]
  const options = requestOptions('DELETE', {id: [ids]}, token);
  return fetch(userDelete, options)
    .then(handleResponse)
    .catch(error => Promise.reject({
    status: error
  }));
}

export const HistoryByUserService = async (params) => {
  const { token, userId, page, orderBy, orderField } = params;
  const options = requestOptions('POST', {}, token);
  return fetch(`${rechargeContactsByUserSearch}?user_id=${userId}&page=${page}&orderBy=${orderBy || 'asc'}&orderField=${orderField || 'id'}`, options)
    .then(handleResponse)
    .catch(error => Promise.reject({
    status: error
  }));
}

export const UserPointsService = async (params) => {
  const { token } = params;
  const options = requestOptions('GET', {}, token);
  return fetch(userPoint, options)
    .then(handleResponse)
    .catch(error => Promise.reject({
    status: error
  }));
}